import React from 'react';

const Header = () => (
    <div className="header bg-danger pb-6">
        <div className="container-fluid">
            <div className="header-body">
                <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                        <h6 className="h2 text-white d-inline-block mb-0 opacity-0">.</h6>
                    </div>
                    <div className="col-lg-6 col-5 text-right">
                    </div>
                </div> 
            </div>
        </div>
    </div>
);

export default Header;


// WEBPACK FOOTER //
// ./src/components/Pages/Establishments/Management/Header.js